<div class="main-container">
    <div class="line-title">
        <span>
            {{barChartTitle}}
        </span>
        <div class="filters">
            <div class="col">
                <div ngbDropdown class="d-inline-block ">
                    <button class="btn btn-custom" id="dropdownBasic1" ngbDropdownToggle>
                        {{selectedFilterValue
                        ?selectedFilterValue.displayName
                        :'Filter'}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                        <button class="dropdown-item" *ngFor="let item of filterValues"
                            (click)="onFilterValueChange(item)">
                            {{item.displayName}}
                        </button>
                    </div>
                </div>
            </div>
            <div class="col">
                <div ngbDropdown class="d-inline-block ">
                    <button class="btn btn-custom" id="dropdownBasic1" ngbDropdownToggle>
                        {{selectedCategory
                        ?selectedCategory.catagorieName
                        : ('page.category' | translate) }}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                        <button class="dropdown-item" *ngFor="let item of categories" (click)="onCategoryChange(item)">
                            {{  language === 'en' ? item.catagorieName : ( item.arCatagoryName ? item.arCatagoryName : item.catagorieName ) }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <ng-container *ngIf="chart"> -->

    <div [hidden]="!chart">
        <canvas class="" id="line" width="900" height="600">{{chart}}</canvas>
        <progress id="animationProgress" max="1" value="0" style="width: 100%"></progress>

    </div>
    <!-- </ng-container> -->
</div>